<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-3">
          <v-alert
            color="primary"
            text
            icon="mdi-clipboard-arrow-down-outline"
            type="info"
            border="bottom"
          >
            INUTILIZADAS
          </v-alert>
        </v-flex>
      </v-col>
    </v-row>
    <div class="d-flex flex-column mb-12 sm-12 lg-12 xl-12 xs-12">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="false"
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">{{ props.header.text }}</span>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nome }}</td>
          <td class="text-xs-left">{{ props.item.data_inicial }}</td>
          <td class="text-xs-left">{{ props.item.funcionario }}</td>

          <td class="text-xs-right">{{ props.item.id_produto }}</td>
          <td class="text-xs-left">{{ props.item.descricao }}</td>
          <td class="text-xs-left">{{ props.item.un }}</td>
          <td class="text-xs-right">{{ props.item.qtde }}</td>
          <td class="text-xs-right">{{ props.item.vencimento }}</td>
        </template>
        <template slot="pageText" slot-scope="props"
          >de{{ props.pageStart }} até {{ props.pageStop }} de
          {{ props.itemsLength }}</template
        >
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>
